import GoogleMapLoader from "../../GoogleMapLoader";

export default {
  name: "AddressRouteModal",
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    show: {
      type: Boolean,
      default: false
    },
    hide: {
      type: Function,
      default: () => {
      }
    },
    onSelect: {
      type: Function,
      default: () => {
      }
    },
    chat_id: {
      type: String,
      default: ""
    },
  },
  components: {
    GoogleMapLoader
  },
  watch: {
    show(val) {
      this.showModal = val;
      if (val && this.item && Object.keys(this.item).length > 0) {
        this.infoRoute = {
          ...this.infoRoute,
          address: "",
          end: {
            latitude: null,
            longitude: null,
          }
        };
        this.info_route = null;
        this.generate_route(this.item);
      }
    }
  },
  created() {
    this.showModal = this.show;
  },
  data() {
    return {
      showModal: false,
      infoRoute: {
        address: "",
        chat_id: null,
        message_id: null,
        start: {
          latitude: null,
          longitude: null
        },
        end: {
          latitude: null,
          longitude: null
        }
      },
      info_route: null
    };
  },
  mounted() {
    const self = this;
    navigator.geolocation.getCurrentPosition(position => {
      self.infoRoute.start.latitude = position.coords.latitude;
      self.infoRoute.start.longitude = position.coords.longitude;
      // Trigger map initialization if item is already set
      if (self.item && Object.keys(self.item).length > 0) {
        self.generate_route(self.item);
      }
    }, error => {
      console.error("Geolocation error:", error);
    });
  },
  methods: {
    generate_route(item) {
      const self = this;
      
      if (!item || Object.keys(item).length === 0) {
        console.warn("AddressRouteModal: No item provided");
        return;
      }

      self.infoRoute.chat_id = item.chat_id;

      if (item.type === "address") {
        self.infoRoute.address = item.address.description;
        self.infoRoute.message_id = item.message_id;
        self.infoRoute.end.latitude = item.address.latitude;
        self.infoRoute.end.longitude = item.address.longitude;
      } else if (item.type === "event") {
        self.infoRoute.address = item.event.address;
        self.infoRoute.message_id = item.message_id;
        self.infoRoute.end.latitude = item.event.latitude;
        self.infoRoute.end.longitude = item.event.longitude;
      }
      
    },
    route(param) {
      const self = this;
      
      if (param && param.routes && param.routes[0] && param.routes[0].legs) {
        self.info_route = param.routes[0].legs[0];
      } else {
        console.warn("? Invalid route data:", param);
      }
    },
    confirm() {
      this.onSelect(this.infoRoute, this.info_route);
      this.hide();
    },
    hideModal() {
      this.showModal = false;
      this.hide();
    }
  }
}